import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Loading from '@/shared/components/Loading';
import { paths } from '@/shared/helpers/paths';
import { UsersPage } from './components/UsersPage';
import './index.scss';

export const cadsAiUserBaseUrl = paths.CADS_AI.USERS;

const Users = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path={cadsAiUserBaseUrl} component={UsersPage} />
      </Switch>
    </Suspense>
  );
};

export default Users;
